import { useEffect, useState } from "react";
// material
import {
  Grid,
  Container,
  Stack,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";

// components
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import PostCard from "../components/Card";
import { Box } from "@mui/system";
import { styled } from "@mui/material/styles";

import avatar from "../assets/img/profile-photo.png";

// ----------------------------------------------------------------------
const LoaderStyle = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  alignContent: "center",
  justifyContent: "center",
  padding: "200px",
}));

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Use own API proxy in production (avoids 520 from third-party proxies)
    // Fall back to AllOrigins in development
    const feedUrl =
      process.env.NODE_ENV === "production"
        ? "/api/medium-feed"
        : `https://api.allorigins.win/raw?url=${encodeURIComponent("https://medium.com/feed/@famzil")}`;

    fetch(feedUrl)
      .then((resp) => resp.text())
      .then((xmlText) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(xmlText, "text/xml");
        const items = doc.getElementsByTagName("item");
        const results = [];

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const getText = (tag) => item.getElementsByTagName(tag)[0]?.textContent ?? "";
          const getContent = () => {
            const encoded = item.getElementsByTagNameNS(
              "http://purl.org/rss/1.0/modules/content/",
              "encoded"
            )[0];
            return encoded?.textContent ?? getText("description") ?? "";
          };

          const content = getContent();
          const imgRegex = /<img[^>]+src="(https?:\/\/[^"]*)"/;
          const match = content.match(imgRegex);
          const imageUrl = match ? match[1] : "";

          const creatorEl = item.getElementsByTagNameNS(
            "http://purl.org/dc/elements/1.1/",
            "creator"
          )[0];
          const author = getText("dc:creator") || (creatorEl?.textContent ?? "");

          results.push({
            id: getText("guid") || getText("link"),
            cover: imageUrl,
            title: getText("title"),
            createdAt: getText("pubDate"),
            link: getText("link"),
            view: "",
            comment: "",
            share: "",
            favorite: "",
            author: {
              name: author,
              avatarUrl: avatar,
            },
          });
        }
        setPosts(results);
      })
      .catch(() => setPosts([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box>
      <title>Blog</title>
      {loading && (
        <LoaderStyle>
          <CircularProgress color="inherit" />
        </LoaderStyle>
      )}
      {!loading && (
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            pt={10}
            pb={3}
          >
            <Typography
              variant="h3"
              sx={{
                fontWeight: "800",
                lineHeight: "1.11429",
                fontFamily: '"Segoe UI"',
                color: "text.primary",
              }}
              gutterBottom
            >
              My Blog
            </Typography>
            <Button
              variant="contained"
              color="primary"
              href="https://famzil.medium.com/"
              target="_blank"
              aria-label="See more posts"
              startIcon={<DoubleArrowIcon />}
            >
              See more
            </Button>
          </Stack>
          {posts ? (
            <Grid container spacing={3}>
              {posts.map((post, index) => (
                <PostCard key={post.id} post={post} index={index} />
              ))}
            </Grid>
          ) : (
            ""
          )}
        </Container>
      )}
    </Box>
  );
}

